import { ChevronDown } from "lucide-react";
import { Dropdown } from "@praesto/ui-kit";
import { useActiveHotel } from "../lib/core";

/**
 * Topbar control for the app-wide active hotel — the FIRST element of the bar,
 * as an editorial block (mono eyebrow STRUTTURA + bold name), not a framed
 * select: the structure is named once, here (C3F v18 topbar treatment). For a
 * multi-hotel owner it's a dropdown driving every hotel-scoped view at once;
 * for a mono-hotel user there is nothing to switch, but the block still shows
 * WHICH structure they are viewing.
 */
export function HotelSwitcher() {
  const { hotelId, reachable, setActiveHotel } = useActiveHotel();
  if (reachable.length === 0) return null;

  const current = reachable.find((h) => h.id === hotelId) ?? reachable[0]!;

  const block = (
    <span className="grid gap-px text-left">
      <span className="text-eyebrow">Struttura</span>
      <span className="whitespace-nowrap text-base font-bold leading-[1.15] tracking-h3 text-fg-default">
        {current.name}
      </span>
    </span>
  );

  if (reachable.length === 1) {
    return (
      <span className="hidden items-center px-2 sm:flex" aria-label="Struttura">
        {block}
      </span>
    );
  }

  return (
    <div className="hidden sm:block">
      <Dropdown
        align="left"
        triggerAriaLabel="Hotel attivo"
        trigger={
          <span className="inline-flex cursor-pointer items-center gap-2.5 whitespace-nowrap rounded-md px-2 py-1 transition-colors duration-fast hover:bg-hover">
            {block}
            <ChevronDown size={14} className="text-fg-muted" aria-hidden />
          </span>
        }
        items={[
          { type: "header" as const, label: "Le tue strutture" },
          ...reachable.map((h) => ({
            type: "item" as const,
            label: h.name,
            onClick: () => setActiveHotel(h.id),
          })),
        ]}
      />
    </div>
  );
}
